import script from "./LocaleView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleView.vue?vue&type=script&setup=true&lang=js"

import "./LocaleView.vue?vue&type=style&index=0&id=5df89e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df89e08"]])

export default __exports__